import { graphql } from '@/generated/gql';

export const SAVE_COLUMN_CONFIG_MUTATION = graphql(/* GraphQL */ `
  mutation SaveColumnConfig($config: jsonb, $domain: String) {
    insert_baseColumnConfig_one(
      object: { config: $config, domain: $domain }
      on_conflict: { constraint: baseColumnConfig_userId_domain_key, update_columns: [config] }
    ) {
      id
      domain
      config
    }
  }
`);
